<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
        <contributions-details>
        </contributions-details>
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import contributionsDetails from './todo-contributions-details'
export default {
    components: {
        contributionsDetails
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-contributions/base-contributions-details.vue